export default __webpack_public_path__ + "static/media/icon-infinity.58bc3d5e.svg";